<template>
    <van-popup class="popWrap" v-model="show" @close="close" position="bottom" round :lazy-render="false" closeable :get-container="getContainer" :style="{maxHeight: '90%'}">
    <div class="tsa-shareWorksDialog">
        <!-- <div class="mask"></div> -->
        <div class="content">
            <!-- <img src="../../../../../assets/images/close3.png" class="close" @click="close" alt=""> -->
            <h2>分享作品</h2>
            <div class="top-area">
                <div class="link-container">
                    <div class="sub-title">
                        <p>分享链接</p>
                    </div>
                    <div class="link-content">
                        <div class="text-info">
                            <p>{{ shareLink }}</p>
                        </div>
                        <div class="share-btns">
                            <div class="btn" @click="copyLink($event)">
                                <p>复制分享链接</p>
                            </div>
                            <div class="btn" @click="copyText($event)">
                                <p>复制分享文案</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="certificate-container">
                    <div class="sub-title">
                        <p>分享证书</p>
                    </div>
                    <div class="certificate-content">
                        <div class="images">
                            <img :src="certificateInfo.certThumbnailStorePathUrl" @click="preview" alt="">
                            <img :src="certificateInfo.enCertThumbnailStorePathUrl" @click="preview('en')" alt="">
                        </div>
                        <p @click="download">下载</p>
                    </div>
                </div>
            </div>
            <div class="bottom-area">
                <div class="set-title">
                    <div class="sub-title">
                        <p>已认证文件的访问权限</p>
                    </div>
                    <div class="reset-btn" @click="setting">
                        <p>{{ basicInfo.setupStatus === 0 ? '设置访问权限' : '重新配置权限' }}</p>
                    </div>
                </div>
                <div class="set-info">
                    <div class="item">
                        <p class="name">访问权限有效期：</p>
                        <p class="value">
                            <template v-if="basicInfo.setupStatus === 0">暂未设置</template>
                            <template v-else-if="basicInfo.setupDuration === -1">长期有效</template>
                            <template v-else-if="basicInfo.setupDuration === 0">{{ basicInfo.setupExpiredAt | timeFormat }}</template>
                        </p>
                    </div>
                    <div class="item">
                        <p class="name">访问码：</p>
                        <p class="value">{{ basicInfo.setupStatus === 0 ? '暂未设置' : basicInfo.accessStatus === 0 ? '无访问码' : basicInfo.accessCode }}</p>
                    </div>
                </div>
                <div class="table-container">
                    <TsaTable
                        :data="tableData"
                        ref="TsaTableV2"
                        maxHeight="400"
                        customRowKey="id"
                        stripe
                    >
                        <!-- <el-table-column
                            type="index"
                            width="60"
                            align="left"
                            label="序号">
                            <template slot-scope="scope">{{ scope.$index + 1 > 9 ? scope.$index + 1 : '0' + (scope.$index + 1) }}</template>
                        </el-table-column> -->
                        <el-table-column prop="fileName" label="文件名称" align="left" min-width="200">
                            <template slot-scope="scope">
                                <div class="cell-container">
                                    {{ scope.row.fileName }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="viewPermission" label="允许他人查看内容" width="140" align="center">
                            <template slot-scope="scope">
                                <div class="table-checkbox-container" :class="scope.row.viewPermission === 0 ? '' : 'checked'">
                                    <span class="icon" :class="[ scope.row.viewPermission === 0 ? 'tsa-icon-close_fill_1' : 'tsa-icon-piliang-quanxuan' ]"></span>
                                    <p>{{ scope.row.viewPermission === 0 ? '不允许' : '允许'}}</p>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="downloadFilePermission" label="允许他人下载文件" width="140" align="center" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <div class="table-checkbox-container" :class="scope.row.downloadFilePermission === 0 ? '' : 'checked'">
                                    <span class="icon" :class="[ scope.row.downloadFilePermission === 0 ? 'tsa-icon-close_fill_1' : 'tsa-icon-piliang-quanxuan' ]"></span>
                                    <p>{{ scope.row.downloadFilePermission === 0 ? '不允许' : '允许'}}</p>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="downloadPdfPermission" label="允许他人下载证书" width="140" align="center" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <div class="table-checkbox-container" :class="scope.row.downloadPdfPermission === 0 ? '' : 'checked'">
                                    <span class="icon" :class="[ scope.row.downloadPdfPermission === 0 ? 'tsa-icon-close_fill_1' : 'tsa-icon-piliang-quanxuan' ]"></span>
                                    <p>{{ scope.row.downloadPdfPermission === 0 ? '不允许' : '允许'}}</p>
                                </div>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column
                            width="40">
                        </el-table-column> -->
                    </TsaTable>
                </div>
                <div class="pager-container">
                    <TsaPager2 v-if="tableData.length > 0" @current-change="currentChange" @size-change="handleSizeChange" :total="total" 
                        :current-page.sync="condition.page" :page-size="condition.size" :page-sizes="pageSizes"/>
                </div>
            </div>
        </div>
        <!-- <div class="btn-groups">
            <div class="btn">
                <TsaButton size="mediumer" @click="confirm" backGroundColor="linear-gradient( 90deg, #0047FF 0%, #2377FF 100%)">关闭</TsaButton>
            </div>
        </div> -->
    </div>
    </van-popup>
</template>

<script>
import { findShareInfoApi, shareFilePageApi, shareApi } from '@/api/copyright/drama'
import commonMixins from '../mixins/common'
import actionsMinix from '@/mixins/actions'
import { downloadFile } from '@/common/copyright/fileUtil'
import { mapState } from 'vuex'
export default {
    data () {
        return {

        }
    },
    mixins: [ commonMixins,actionsMinix ],
    computed: {
        ...mapState({
            parentIframe: (state) => state.app.parentIframe,
        }),
    },
    methods: {
        getContainer() {
            return document.querySelector('.main');
        },
        open ({ id, rightsInfo, basicInfo, certificateInfo, onConfirm } = {}) {
            this.onConfirm = onConfirm
            this.show = true
            this.rightsInfo = rightsInfo || {}
            this.certificateInfo = certificateInfo || {}
            this.basicInfo = basicInfo || {}
            this.shareLink = `${process.env.VUE_APP_VERIFY}/dramaResult?s=${this.basicInfo.randomKey}`
            this.dramaId = id
            console.log(this.basicInfo)
            this.tableApi()
        },
        setting () {
            this.show = false
            this.$emit('on-setting', {
                id: this.dramaId,
                ...this.rightsInfo,
                ...this.basicInfo,
                ...this.certificateInfo,
            })
        },
        copyLink () {
            this.$copyText(this.shareLink).then(() => {
                this.$TsaToastV2.show({
                    message: '复制成功',
                    type: 'success'
                })
            }).catch(() => {
                this.$TsaToastV2.show({
                    message: '复制失败',
                    type: 'error'
                })
            })
        },
        copyText () {
            let text = `「${this.rightsInfo.owner}」对作品《${this.basicInfo.name}》成功申请了可信时间戳版权认证，点击查看详情：${this.shareLink}`
            this.$copyText(text).then(() => {
                this.$TsaToastV2.show({
                    message: '复制成功',
                    type: 'success'
                })
            }).catch(() => {
                this.$TsaToastV2.show({
                    message: '复制失败',
                    type: 'error'
                })
            })
        },
        download () {
            let {parentIframe} =this
            if(parentIframe === 'ANDROID-RIGHTS' || parentIframe === 'IOS-RIGHTS' || parentIframe === 'HARMONYOSNEXT-RIGHTS' || parentIframe ==='WEIXIN'){
                this.$TsaAlertV2.show({
                    title: '下载证书',
                    message: '请用手机浏览器打开后进行下载证书，或者在电脑端打开<span style="word-break: break-all;">https://ipr.tsa.cn/copyright/certifiedWork</span>下载证书。',
                    type: 'warn',
                    confirmButtonText: '我知道了',
                    onConfirm: () => {
                        this.$TsaAlertV2.hide()
                    },
                })
            }else{
                downloadFile(this.certificateInfo.certStorePathUrl)
            } 
        },
        preview (e) {
            this.customViewerApi = this.$viewerApi({
                images: [e=='en'?this.certificateInfo.enCertThumbnailStorePathUrl : this.certificateInfo.certThumbnailStorePathUrl],
                options: {
                    title: false,
                    toolbar: false,
                    navbar: false,
                    button: false,
                    viewed() {
                        var that = this
                        document.querySelector('.viewer-container .viewer-canvas').onclick = function (e) {
                            if (e.target.className === 'viewer-canvas') {
                                that.viewer.hide()
                            }
                        }
                    }
                    // button: false
                }
            })
        },
        close () {
            this.show = false
        }
    },
    beforeDestroy () {
        this.customViewerApi && this.customViewerApi.hide()
    },
}
</script>

<style lang="scss" scoped>
    .popWrap{
        overflow: auto;
        display: flex;
        flex-direction: column;
    }
    .tsa-shareWorksDialog {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        .content {
            display: flex;
            flex-direction: column;
            flex: 1;
            width: 100%;
            background: #fff;
            box-sizing: border-box;
            padding:37px 16px 0;
            overflow: hidden;
            h2 {
                font-weight: bold;
                font-size: 20px;
                color: #000000;
                margin-bottom: 20px;
            }
            .sub-title {
                position: relative;
                padding-left: 11px;
                p {
                    font-weight: bold;
                    font-size: 16px;
                    color: #000000;
                }
                &::after {
                    content: '';
                    position: absolute;
                    top: 50%;
                    left: 0;
                    transform: translateY(-50%);
                    width: 3px;
                    height: 20px;
                    background: #2368F1;
                }
            }
            .top-area {
                width: 100%;
                display: flex;
                margin-bottom: 25px;
                position: relative;
                justify-content: space-between;
                overflow: hidden;
                .link-container {
                    margin-right: 5px;
                    .sub-title {
                        margin-bottom: 10px;
                    }
                    .link-content {
                        padding-left: 5px;
                        .text-info {
                            max-width: 260px;
                            height: 72px;
                            padding: 6px 11px;
                            background: #F7F7F9;
                            border-radius: 11px;
                            margin-bottom: 20px;
                            box-sizing: border-box;
                            p {
                                width: 100%;
                                word-break: break-all;
                                font-size: 14px;
                                color: #000000;
                            }
                        }
                        .share-btns {
                            display: flex;
                            .btn {
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                width: 108px;
                                height: 34px;
                                background: #0047FF;
                                border-radius: 8px;
                                border: 1px solid #0047FF;
                                margin-right: 20px;
                                cursor: pointer;
                                &:hover {
                                    background: #1F5EFF;
                                }
                                p {
                                    font-size: 14px;
                                    color: #FFFFFF;
                                }
                                &:last-child{
                                    margin-right: 0;
                                }
                            }
                        }
                    }
                }
                .certificate-container {
                    // width: 205px;
                    .sub-title {
                        margin-bottom: 7px;
                        white-space: nowrap;
                    }
                    .certificate-content {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        .images{
                            display: flex;
                            img {
                                width: 60px;
                                height: 85px;
                                cursor: pointer;
                                &:nth-child(2){
                                    margin-left: 5px;
                                }
                            }
                        }
                        p {
                            margin-top: 13px;
                            font-size: 14px;
                            line-height: 22px;
                            color: #0047FF;
                            margin-bottom: 4px;
                            cursor: pointer;
                        }
                    }
                }
            }
            .bottom-area {
                flex: 1;
                width: 100%;
                display: flex;
                flex-direction: column;
                padding-bottom:20px;
                overflow: hidden;
                .set-title {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    .reset-btn {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 108px;
                        height: 34px;
                        border-radius: 8px;
                        border: 1px solid #0047FF;
                        cursor: pointer;
                        &:hover {
                            background: #f8f8f8;
                        }
                        p {
                            font-size: 14px;
                            line-height: normal;
                            color: #0047FF;
                        }
                    }
                }
                .set-info {
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 18px;
                    margin-top:17px;
                    flex-wrap:wrap;
                    .item {
                        display: flex;
                        align-items: center;
                        &:first-child {
                            margin-right: 0px;
                        }
                        .name {
                            font-size: 16px;
                            color: #666666;
                            margin-right: 8px;
                        }
                        .value {
                            font-size: 16px;
                            color: #000000;
                        }
                    }
                }
                /deep/.table-container {
                    flex: 1;
                    overflow: auto;
                    margin-bottom: 20px;
                    .table-checkbox-container {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        &.checked {
                            .icon {
                                color: #14AE5C;
                            }
                        }
                        .icon {
                            font-size: 14px;
                            color: #B8BCC4;
                            margin-right: 7px;
                        }
                        p {
                            font-size: 14px;
                            color: #000000;
                        }
                    }
                   .cell{
                        padding: 0 !important;
                        .cell-container{
                            width: 100%;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            word-break: break-all;
                            white-space: nowrap;
                        }
                        .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
                            background-color:#0047FF;
                            background-color:#0047FF;
                        }
                    }
                }
                .pager-container {
                    display: flex;
                    justify-content: flex-end;
                }
            }
            .btn-group {
                display: flex;
                width: 100%;
                justify-content: flex-end;
                .btn {
                    width: 120px;
                }
            }
        }
        // .btn-groups {
        //     height: 76px;
        //     box-shadow: 0px -4px 20px 0px rgba(0,0,0,0.05);
        //     display: flex;
        //     display: flex;
        //     justify-content: center;
        //     align-items: center;
        //     width: 100%;
        //     box-sizing: border-box;
        //     .btn {
        //         width: 166px;
        //         height: 44px;
        //         margin: 0 24px;
        //     }
        // }
    }
    @media screen and (max-width:400px) {
        .tsa-shareWorksDialog{
            .content{
                .top-area{
                    .link-container{
                        .link-content{
                            .text-info{
                                padding: 6px;
                            }
                            .share-btns {
                                .btn{
                                    width: 95px;
                                    margin-right: 10px;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>